import type { AlertColor } from "@mui/material";
import { Alert } from "@mui/material";
import useDefinedContext from "@entrilia/shared/hooks/useDefinedContext";
import { convertISODate } from "@entrilia/shared/utilities/dateUtils";
import type { InvestorCommunicationStatus } from "@entrilia/shared/api/investorCommunicationsTypes";
import InvestorCommunicationContext from "../InvestorCommunicationContext";

const statusSeverities: Record<InvestorCommunicationStatus, AlertColor> = {
  Draft: "info",
  Preview: "info",
  Live: "success",
};

const getStatusMessage = (status: InvestorCommunicationStatus, publishedToLiveAt?: string): string => {
  if (status === "Draft") {
    return "Draft · not visible to investors.";
  }

  if (status === "Preview") {
    return "In preview · visible to internal reviewers only, not to investors.";
  }

  const publishedDate = convertISODate(publishedToLiveAt);

  return publishedDate ? `Live since ${publishedDate} · visible to investors.` : "Live · visible to investors.";
};

const InvestorCommunicationStatusAlert = () => {
  const { investorCommunication } = useDefinedContext(InvestorCommunicationContext, "InvestorCommunicationContext");

  return (
    <Alert severity={statusSeverities[investorCommunication.status]}>
      {getStatusMessage(investorCommunication.status, investorCommunication.publishedToLiveAt)}
    </Alert>
  );
};

export default InvestorCommunicationStatusAlert;
